import { Fragment, useState } from "react";
import { MenuItem } from "@mui/material";
import { Broadcast } from "types/broadcast";
import { SystemMessageItem } from "./SystemMessageItem";
import { SystemMessage } from "./SystemMessage";

const NotificationMenuList = ({ notifications, onClick }: { notifications: Broadcast[]; onClick?: () => void }) => {
  const [selectedMessage, setSelectedMessage] = useState<Broadcast | null>(null);

  const handleClick = (message: Broadcast) => {
    console.log("Conversation item clicked:", message.id);

    setSelectedMessage(message);

    if (onClick) onClick();
  };

  if (!notifications || notifications.length === 0) {
    return (
      <MenuItem disabled>
        {/* <FormattedMessage id="message.no-messages" defaultMessage="Inga nya meddelanden" /> */}
      </MenuItem>
    );
  }

  return (
    <>
      {notifications.map((item) => (
        <Fragment key={item.id}>
          <MenuItem onClick={() => handleClick(item)}>
            <SystemMessageItem key={item.id} message={item} />
          </MenuItem>
        </Fragment>
      ))}

      {selectedMessage && <SystemMessage message={selectedMessage} onClose={() => setSelectedMessage(null)} />}
    </>
  );
};

export default NotificationMenuList;
